/* eslint @typescript-eslint/no-redundant-type-constituents: 0 */
import { IntlMessageFormat } from 'intl-messageformat';

const _alert__created_with_registration_fr = new IntlMessageFormat(
    [
        {
            type: 0,
            value: "[p]Nous vous confirmons la réception et l'enregistrement de votre demande de devis.[/p]\n[p][b]Afin de la valider[/b], merci de [b]cliquer sur le lien[/b] que nous venons de vous envoyer par mail.[/p]\n[p]L'équipe de Go Africa Online vous tiendra rapidement au courant de son envoi aux professionnels concernés.[/p]",
        },
    ],
    'fr',
);

export function alert__created_with_registration(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _alert__created_with_registration_fr.format(args) as unknown as string;
    }

    return _alert__created_with_registration_fr.format(args) as unknown as string;
}

const _alert__created_fr = new IntlMessageFormat(
    [
        {
            type: 0,
            value: "[p]\n    Nous vous confirmons la réception et l'enregistrement de votre demande de devis. [br /]\n    L'équipe de Go Africa Online vous tiendra rapidement au courant de sa validation par mail.\n[/p]",
        },
    ],
    'fr',
);

export function alert__created(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _alert__created_fr.format(args) as unknown as string;
    }

    return _alert__created_fr.format(args) as unknown as string;
}

const _modal__description_text_fr = new IntlMessageFormat(
    [
        {
            type: 0,
            value: "[p]\n    Évitez la corvée d'envoyer une demande de devis à chaque professionnel: [br /]\n    Rédigez [b]une seule demande[/b] et Go Africa Online l'enverra à tous les professionnels du secteur approprié. [br /]\n    Ils vous retournerons leurs devis que vous pourrez sélectionner sereinement.\n[/p]",
        },
    ],
    'fr',
);

export function modal__description_text(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _modal__description_text_fr.format(args) as unknown as string;
    }

    return _modal__description_text_fr.format(args) as unknown as string;
}

const _modal__title_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Demande de devis sans engagement de votre part' }],
    'fr',
);

export function modal__title(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _modal__title_fr.format(args) as unknown as string;
    }

    return _modal__title_fr.format(args) as unknown as string;
}
